import { useTranslation } from "react-i18next";
import { Building2, CalendarDays, CheckSquare, FileText } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";

// صف موظف موقوف الراتب: البيانات + سبب الإيقاف + زر الاستئناف.
export const HoldRow = ({ item, busy, onRelease }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-border/40 p-4 last:border-0"
         data-testid={`hold-row-${item.id}`}>
      <div className="grid gap-1 text-xs">
        <p className="text-base font-black">{item.employee_name || "—"}</p>
        <p className="text-muted-foreground">{item.employee_email}</p>
        <p className="flex items-center gap-1.5 text-muted-foreground">
          <Building2 className="h-3.5 w-3.5" /> {item.branch_name || "—"}
        </p>
      </div>
      <div className="grid gap-1 text-xs">
        <p className="flex items-center gap-1.5 font-bold text-destructive">
          <CalendarDays className="h-3.5 w-3.5" />
          {t("holds.heldAt")}: {String(item.held_at || "").slice(0, 10)}
        </p>
        <p className="flex items-center gap-1.5 font-mono text-[11px] text-muted-foreground" dir="ltr">
          <FileText className="h-3.5 w-3.5" /> {item.reason}
        </p>
      </div>
      <NeuButton className="bg-emerald-600 px-5 py-2.5 text-white hover:bg-emerald-700"
                 data-testid={`hold-release-${item.id}`} disabled={busy}
                 onClick={() => onRelease(item.id)}>
        <CheckSquare className="inline h-4 w-4" /> {t("holds.release")}
      </NeuButton>
    </div>
  );
};
